import NProgress from 'nprogress'
import '@/assets/css/nprogress.css'

NProgress.configure({ 
  showSpinner: false
});

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()

  router.beforeEach(() => {
    NProgress.start()
  })

  router.afterEach(() => {
    NProgress.done()
  })

  router.onError(() => {
    NProgress.done()
  })
})